export default __webpack_public_path__ + "assets/img/historyOffering.c10c6b0212d8924d0ca69ad2a35af5d0.png";